import type React from "react";
import { useTranslation } from "react-i18next";

import { TeacherModals } from "constants/modals-constants";

import { useDomainHandler } from "hooks/useDomainHandler";
import { useModal } from "hooks/useModal";

import { Heading2 } from "styles/elements/Headings";
import { ParagraphLarge } from "styles/elements/Texts";
import { CssButton, CssFlex, CssIcon } from "styles/helpers/layout";

import { CreateEmailInviteModal } from "./components/CreateEmailInviteModal/CreateEmailInviteModal";
import { EmailInviteBundleDetailsModal } from "./components/EmailInviteBundleDetailsModal/EmailInviteBundleDetailsModal";
import { InvitationBundleList } from "./components/InvitationBundleList/InvitationBundleList";

export const InviteManagementPage: React.FC = () => {
  const { t } = useTranslation("teacher-dashboard");
  const { getStudentTermByDomain } = useDomainHandler();

  const { openModal } = useModal();

  return (
    <CssFlex flexDirection="column" gap={0.5}>
      <CssFlex justifyContent="space-between" gap={1}>
        <Heading2>{t("invitationManagement.title")}</Heading2>
        <CssButton
          dataCy="create-invite-bundle-button"
          variant="primary"
          onClick={() => openModal(TeacherModals.CreateEmailInviteBundle)}
        >
          <CssFlex alignItems="center" gap={0.5}>
            <CssIcon iconName="far fa-plus" />
            {t("invitationManagement.createInviteButton", {
              studentTerm: getStudentTermByDomain({ usePlural: true }),
            })}
          </CssFlex>
        </CssButton>
      </CssFlex>
      <ParagraphLarge>
        {t("invitationManagement.description", {
          studentTerm: getStudentTermByDomain({ usePlural: true }),
        })}
      </ParagraphLarge>
      {/* -- Invite bundle list -- */}
      <InvitationBundleList />
      {/* -- Invite creation modal -- */}
      <CreateEmailInviteModal />
      {/* -- Invite bundle details -- */}
      <EmailInviteBundleDetailsModal />
    </CssFlex>
  );
};
